/*
 * 薪酬报表
 *
 * *
 * */
import { userClient } from "@/api/userClient";
import { StatementOfSalaryReq } from "@/pbjs/external/user/user_pb";
import { Page } from "@/utils/index";
import { setPage } from "@/utils/request";
import InnerRequest from "./request";
export interface Options {
  UserGroupId?: number;
  PayrollCycleCondition?: number;
  IsNewEmployee?: number;
  EmployeeId?: string;
  EmployeeName?: string;
  Page: Page;
}
export function setStatementOfSalaryReq(arg: Options) {
  let request: any = new StatementOfSalaryReq();
  request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
  request.setPayrollcyclecondition(arg.PayrollCycleCondition); // 发薪周期的查询条件（当前周期，上个周期，当前月）
  request.setUsergroupid(arg.UserGroupId); // 查询在哪个用户组下
  request.setIsnewemployee(arg.IsNewEmployee); // 工单分类
  request.setEmployeeid(arg.EmployeeId); // 雇员ID
  request.setEmployeename(arg.EmployeeName); // 雇员姓名
  return request;
}
export const statementOfSalaryRequest = new InnerRequest(
  userClient,
  userClient.statementOfSalary
);
export const dwnloadStatementOfSalary = new InnerRequest(
  userClient,
  userClient.downloadStatementOfSalary
);
